// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__3iHOo","img":"Image_img__ps9s6","skeleton":"Image_skeleton__gMTW9"};